import { queryOptions, useQuery } from '@tanstack/react-query';

import { menusApi } from '../api/menus-api';

import { menuKeys } from './menu-keys';

export function menuQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: menuKeys.detail(storeId, id),
    queryFn: () => menusApi.get(storeId, id),
  });
}

export function useMenu(storeId: string, id: string) {
  return useQuery(menuQueryOptions(storeId, id));
}
